/* Poster zoom only. Booking is owned by the existing SolReservation component. */
class SolCollaboration extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = {signal: this.controller.signal};
    const dialog = this.querySelector('.sc-poster-dialog');
    const trigger = this.querySelector('[data-sc-open]');
    if (!dialog || !trigger) return;
    trigger.addEventListener('click', () => dialog.showModal(), options);
    this.querySelector('[data-sc-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, options);
    dialog.addEventListener('close', () => trigger.focus({preventScroll: true}), options);
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('sol-collaboration')) customElements.define('sol-collaboration', SolCollaboration);
